import {useNavigate} from "react-router-dom";
import React, {useContext, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import {Col, Modal, Row} from "react-bootstrap";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import {customerConvertData} from "../common/api/CustomerProfileApi";

export default function AdminImportCustomers({show, companyGuid, importType, handleClose, callback, isNew}) {

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();
  const [customerInput, setCustomerInput] = useState('');
  const [customerResult, setCustomerResult] = useState([]);


  const doToast = () => {
    let _context = {...context};
    const toastMessage = 'Import successful.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});
  }

  const [processing, setProcessing] = useState(false);
  const [importResponse, setImportResponse] = useState();

  const saveCustomerInput = () => {
    setProcessing(true);
    setImportResponse(null);
    customerConvertData({
      data: customerInput,
      commit: true,
      companyGuid: companyGuid,
      fileData: fileData
    }, importType).then(result => {
      setProcessing(false);
      setImportResponse(result);
      callback(result.message, true)
    });
  }


  const processCustomerInput = () => {
    setProcessing(true);
    setImportResponse(null);
    customerConvertData({
      data: customerInput,
      fileData: fileData
    }, importType).then(result => {
      setProcessing(false);
      setImportResponse(result);
      callback(result.message, false);
    });
  }

  const [fileData, setFileData] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setFileData(null)
      return;
    }

    const reader = new FileReader();

    reader.onload = function (evt) {
      setFileData(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);
  }

  return (

    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form>
        <Modal.Header closeButton>
          <Modal.Title>Import Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <MDBox py={3}>
            <MDBox mb={3}>

              <MDTypography variant="p" color="secondary" fontWeight="light">
                Import Customers from {importType} Template File.
              </MDTypography>

              {importType === 'generic' && <><h5>Generic Columns</h5><p>FirstName, LastName, Email, Phone, StreetAddress1, StreetAddress2, City, State, ZipCode</p></>}


              {importResponse && <p>{importResponse.message}</p>}

              <Grid container spacing={2}>
                <Grid item sm={12}>
                  <Row className={'my-4'}>

                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group mt-2">
                        {/*<TextareaAutosize*/}
                        {/*  autoComplete="off"*/}
                        {/*  minRows={15}*/}
                        {/*  maxRows={15}*/}
                        {/*  onChange={(e) => {*/}
                        {/*    setCustomerInput(e.target.value);*/}
                        {/*  }}*/}
                        {/*  className="form-control" id="desc"*/}
                        {/*  placeholder={'Paste Customer Import'}/>*/}
                        <label htmlFor="importFile">CSV File</label>
                        <input type="file"
                               accept="text/csv"
                               onChange={(e)=>{
                                 handleFileChange(e);
                               }}
                               autoComplete="off"
                               className="form-control" id="importFile"/>
                      </div>

                    </Col>
                  </Row>
                  <Row className={'my-4'}>
                    <Col className={'col'} sm={12} xs={12}>
                      <MDButton
                        color="info"
                        size="small"
                        className="pull-right"
                        disabled={!fileData || processing}
                        onClick={(e) => {
                          saveCustomerInput()
                        }}>
                        {processing ? 'Saving...' : 'Save'}
                      </MDButton>

                      <MDButton
                        color="info"
                        size="small"
                        className="pull-right mx-2"
                        disabled={!fileData || processing}
                        onClick={(e) => {
                          processCustomerInput()
                        }}>
                        {processing ? 'Converting...' : 'Preview'}
                      </MDButton>

                    </Col>
                  </Row>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </Modal.Body>
      </form>
    </Modal>
  );
}